const states = {
  new: {
    value: "new",
    label: "New",
    parent: "new",
    color: "inProgress",
    chartColor: "#eaaf39",
    order: 1,
  },
  review: {
    value: "review",
    label: "Ready for review",
    parent: "new",
    color: "inProgress",
    chartColor: "#eaaf39",
    order: 2,
  },
  qualified: {
    value: "qualified",
    label: "Qualified",
    parent: "published",
    color: "done",
    chartColor: "#009EF7",
    order: 3,
  },
  investment: {
    value: "investment",
    label: "Investment",
    parent: "published",
    color: "done",
    chartColor: "#009EF7",
    order: 4,
  },
  unqualified: {
    value: "unqualified",
    label: "Unqualified",
    parent: "closed",
    color: "denied",
    chartColor: "#c0c0c0",
    order: 5,
  },
  archived: {
    value: "archived",
    label: "Archived",
    parent: "closed",
    color: "denied",
    chartColor: "#c0c0c0",
    order: 6,
  },
};

module.exports = states;
